<template>
    <modal size="lg" :height-max="false" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editLocationModal">
        <template v-slot:title>
            <h3 class="modal-title">Edit Location</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Organizational Level: </span>{{ orgLevelLabel }}</div>
                </div>
            </div>

            <form-errors :errors="formErrors"/>

            <div class="row">
                <div class="col-12">
                    <form>
                        <div class="form-row" v-for="(opt, idx) in formData">
                            <div class="col">
                                <form-input type="text" :deletable="true" :toDelete="opt.to_delete" :nocaps="true" v-model="opt.org_level_code" :placeholder="'Option ' + String(idx + 1)" @delete="onOptionDelete(idx)"/>
                            </div>
                        </div>
                        <a href class="btn btn-link" @click.prevent="addOption()"><i class="far fa-plus mr-hf"></i>Add Another Value Option</a>
                    </form>
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="closeModal()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', 'orgs', 'level'],
    mixins: [FormMixin, ModalMixin],
    components: {},
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    watch: {
        orgs() {
            this.reset()
        }
    },
    mounted() {},
    computed: {
        orgLevelLabel() {
            return this.client[`org_level_${this.level}_label`]
        },
    },
    methods: {
        makeFormData() {
            let orgs = JSON.parse(JSON.stringify(this.orgs.filter(o => o.org_level == this.level)))
            const data = orgs.map(({ id, org_level_code }) => ({ id, org_level_code }));
            return data
        },
        addOption() {
            this.formData.push({id: '', org_level_code: ''})
        },
        getFormData() {
            return this.formData.filter(o => !o.to_delete)
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.post(`/clients/${this.client.id}/settings/company-orgs/level/${this.level}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
        onOptionDelete(idx) {
            this.formData[idx]['to_delete'] = true
        },
        closeModal() {
            if (this.formData.find(o => o.to_delete)) {
                if (confirm("Are you sure you want to discard your unsaved changes?")) {
                    this.close()
                }
            } else {
                this.close()
            }
        }
    }
}
</script>
